import React, { Component } from "react";
import { connect } from "react-redux";
import { Segment, Form, Grid, Button, Table } from "semantic-ui-react";
import _ from "lodash";
import FormHeader from "./FormHeader";
import SearchControls from "./SearchControls";
import settings from "../../settings";
import InlineError from "../messages/InlineError";
import { hideCaseManagement } from "../../utils/PageHelper";

function getCurrancyValue(value) {
  if (!value || value === "") return 0;
  const lowerCaseValue = value.toLowerCase();
  if (
    lowerCaseValue === "included" ||
    lowerCaseValue === "free" ||
    lowerCaseValue === "varies"
  )
    return 0;
  return Number(value.replace(/[^0-9.-]+/g, ""));
}

class SearchFormTemplate extends Component {

  state = {
      errors: [],
      qtOpen: true,
      flatRateChecked: false,
      firstErrorFieldName: undefined,
    };

  onChange = (e, data) => {
    const formData = this.props.defaultFormData;
    formData[data.name] = data.value;
    if (data.value && data.value !== "" && data.name) {
      const errors = this.state.errors;
      const errorKeys = Object.keys(errors);
      if (errorKeys.includes(data.name)) {
        delete errors[data.name];
        this.setState({ errors });
      }
    }

    this.props.onFormDataChange(
      `Form_${this.props.formId}`,
      formData,
      data.name
    );
  };

  onClear = (e) => {
    e.preventDefault();
    const formData = this.props.defaultFormData;
    this.props.onFormDataChange(`Form_${this.props.formId}`, {
      formID: formData.formID,
    });
  };

  onSubmit = (e) => {
    e.preventDefault();
    const errors = [];
    const firstErrorFieldName = this.validateForm(errors);
    if (Object.keys(errors).length === 0) {
      const formData = this.props.defaultFormData;
      if (formData.state === "-1") delete formData.state;
      if (formData.city === "-1") delete formData.city;
      this.props.submit(this, formData);
    } else {
      this.setState({ errors, firstErrorFieldName });
    }
  };

  onKeyPress = (e) => {
    if (e.which === 13) {
      e.preventDefault();
      this.onSubmit(e);
    }
  };

  validateForm = (errors) => {
    let firstErrorFieldName;
    const requiredControls = _.filter(
      this.props.formControls,
      (a) => a.FieldRequired === true
    );
    const formData = this.props.defaultFormData;
    const validationRuleNames = Object.keys(settings.validationRules);
    _.forEach(requiredControls, (cont) => {
      if (
        formData[cont.FieldName] === undefined ||
        formData[cont.FieldName] === null ||
        formData[cont.FieldName] === "" ||
        formData[cont.FieldName] === "-1"
      ) {
        if (!firstErrorFieldName) firstErrorFieldName = cont.FieldName;
        errors[cont.FieldName] = `The ${cont.FieldName} cannot be empty`;
      } else if (validationRuleNames.includes(cont.FieldType)) {
        const validationRule = settings.validationRules[cont.FieldType];
        if (!validationRule.regex.test(formData[cont.FieldName])) {
          if (!firstErrorFieldName) firstErrorFieldName = cont.FieldName;
          errors[cont.FieldName] = validationRule.errorMessage;
        }
      }
    });
    if (this.props.userAccount.flatRate) {
      const flatRateElement = document.getElementById(
        `FlatRate_${this.props.formId}`
      );
      if (flatRateElement && !flatRateElement.checked) {
        if (!firstErrorFieldName) flatRateElement.focus();
        errors[`FlatRate_${this.props.formId}`] = "Please agree to pay";
      }
    }
    return firstErrorFieldName;
  };

  toggleQuickTips = () => {
    this.setState({ qtOpen: !this.state.qtOpen });
  };

  handleFlatRateCheck = (name) => {
    const errors = this.state.errors;
    if (errors) {
      delete errors[name];
    }
    this.setState({ errors, flatRate: !this.state.flatRate });
  };

  // hideCaseManagement = () => {
  //   const menuNumbers =
  //     settings.hideCaseManagementAtFormsForMenu || [];

  //   const url = window.location.pathname;

  //   return menuNumbers.some(
  //     number => url.indexOf(`/${number}`) !== -1
  //   );
  // };

  render() {
    const { isLeftSearch, userAccount } = this.props;
    // const {hideCaseManagementAtFormsForMenu} = settings;
    // const currentUrl = window.location.href;
    // if(currentUrl.indexOf)
    // console.log(hideCaseManagementAtFormsForMenu);
    const controls = (
      <SearchControls
        formControls={this.props.formControls}
        notifyChangeToForm={this.onChange}
        errors={this.state.errors}
        defaultFormData={this.props.defaultFormData}
        firstErrorFieldName={this.state.firstErrorFieldName}
        reportId={this.props.leftMenuReportId}
        isLeftSearch={isLeftSearch}
      />
    );
    const report = _.find(
      this.props.uiData.Reports,
      (r) => r.ReportID === this.props.leftMenuReportId
    );
    let searchCostMessage = "";
    if (this.props.userAccount.flatRate) {
      if (report) {
        const { SearchResultCost, SearchNoResultCost } = report;
        const searchResultCostValue = getCurrancyValue(SearchResultCost);
        const searchNoResultCostValue = getCurrancyValue(SearchNoResultCost);
        if (searchResultCostValue > 0) {
          searchCostMessage = (
            <span>
              {`I agree to pay ${SearchResultCost}${searchNoResultCostValue > 0
                ? ` (${SearchNoResultCost} - in case of no hit)`
                : ""
                } for this search`}
              <br />
            </span>
          );
        }
      }
      if (searchCostMessage !== "")
        searchCostMessage = (
          <span>
            {searchCostMessage}
            {"I understand it's not included in my plan."}
            <br />
          </span>
        );
    }
    const hideRightSection = hideCaseManagement(settings.hideCaseManagementAtFormsForReports, this.props.leftMenuReportId || report.ReportID);
    const tableClass = hideRightSection && !isLeftSearch ? "table-no-border-and-padding width-50-percent-mandatory" : "table-no-border-and-padding";
    return (
      <Segment
        className={
          "table-no-border form-padding box-shadow-none background-color-transparent"
        }
      >
        <Form onKeyPress={this.onKeyPress}>
          <Segment
            className={
              "table-no-border box-shadow-none background-color-transparent"
            }
            style={{ padding: "0 10% !important" }}
          >
            <Table className={tableClass}>
              <Table.Body>
                <Table.Row>
                  <Table.Cell width={isLeftSearch ? 16 : 8}>
                    <Grid
                      stackable
                      columns={2}
                      className={
                        "form-control-grid background-color-transparent"
                      }
                    >
                      {controls}
                    </Grid>
                  </Table.Cell>
                  {/* {!isLeftSearch &&
                    <Table.Cell width={1}>
                      &nbsp;
                    </Table.Cell>} */}
                  {!hideRightSection && !isLeftSearch &&
                    <Table.Cell width={8}>
                      <FormHeader
                        toggleQuickTips={this.toggleQuickTips}
                        currentMenuHierarchy={this.props.currentMenuHierarchy}
                        leftMenuReportId={this.props.leftMenuReportId}
                        currentFormId={this.props.defaultFormData.formID}
                        currentFormTitle={
                          this.props.formControls && this.props.formControls[0].FormTitle
                        }
                        isLeftSearch={isLeftSearch}
                      />
                    </Table.Cell>}
                </Table.Row>
              </Table.Body>
            </Table>
          </Segment>
          <Grid stackable columns={2}>
            {settings.showAuditMessageReports.includes(
              this.props.leftMenuReportId
            ) && (
                <Grid.Row className={"medium-font"}>
                  <Grid.Column width={16} className={"text-center"}>
                    <span>
                      All Searches{" "}
                      <b>
                        <u>MUST</u>
                      </b>{" "}
                      have a legitimate business purpose and are subject to audit
                    </span>{" "}
                  </Grid.Column>
                </Grid.Row>
              )}
            {searchCostMessage !== "" && (
              <Grid.Row>
                <Grid.Column width={16} className={"text-center"}>
                  <input
                    id={`FlatRate_${this.props.formId}`}
                    name={`FlatRate_${this.props.formId}`}
                    // checked={this.state.flatRateChecked}
                    onChange={() =>
                      this.handleFlatRateCheck(`FlatRate_${this.props.formId}`)
                    }
                    type="checkbox"
                    className={`ui checkbox margin-top-2`}
                  />{" "}
                  {searchCostMessage}
                  {this.state.errors &&
                    this.state.errors[`FlatRate_${this.props.formId}`] && (
                      <InlineError
                        text={
                          this.state.errors[`FlatRate_${this.props.formId}`]
                        }
                      />
                    )}
                </Grid.Column>
              </Grid.Row>
            )}
            {!settings.deniedSearchForms.includes(this.props.formId) && (
              <Grid.Row>
                <Grid.Column width={16}>
                  <Segment
                    className={
                      "table-no-border-and-padding text-center box-shadow-none background-color-transparent margin-bottom-10"
                    }
                  >
                    <Button
                      className={
                        userAccount.acctTheme === 0 ? "classic-submit" : ""
                      }
                      primary
                      onClick={this.onSubmit}
                    >
                      Search
                    </Button>
                    <Button
                      className={userAccount.acctTheme === 0 ? "btnClear" : ""}
                      onClick={this.onClear}
                    >
                      Clear
                    </Button>
                    <br />
                  </Segment>
                </Grid.Column>
              </Grid.Row>
            )}
          </Grid>
        </Form>
      </Segment>
    );
  }
}

function mapStateToProps(state) {
  return { uiData: state.uiData, userAccount: state.userAccount };
}

export default connect(mapStateToProps, null)(SearchFormTemplate);



// WEBPACK FOOTER //
// ./src/components/searches/SearchFormTemplate.js